import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPause = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M128 128h320v768h-320zM576 128h320v768h-320z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgPause);
export default ForwardRef;
